import * as React from 'react';
import { IconProps } from '../types';

const IcMenuReport = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M3.167 2c.368 0 .666.298.666.667v18h18a.667.667 0 1 1 0 1.333h-18A1.334 1.334 0 0 1 2.5 20.667v-18c0-.369.298-.667.667-.667Z"
      clipRule="evenodd"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M6.667 11.333a.167.167 0 0 0-.167.167v6.333c0 .092.075.167.167.167h1.666a.167.167 0 0 0 .167-.167V11.5a.167.167 0 0 0-.167-.167H6.667Zm-1.5.167a1.5 1.5 0 0 1 1.5-1.5h1.666a1.5 1.5 0 0 1 1.5 1.5v6.333a1.5 1.5 0 0 1-1.5 1.5H6.667a1.5 1.5 0 0 1-1.5-1.5V11.5ZM12.667 9.333a.167.167 0 0 0-.167.167v8.333c0 .092.075.167.167.167h1.666a.167.167 0 0 0 .167-.167V9.5a.167.167 0 0 0-.167-.167h-1.666Zm-1.5.167a1.5 1.5 0 0 1 1.5-1.5h1.666a1.5 1.5 0 0 1 1.5 1.5v8.333a1.5 1.5 0 0 1-1.5 1.5h-1.666a1.5 1.5 0 0 1-1.5-1.5V9.5ZM18.652 6.667a.167.167 0 0 0-.167.166v11c0 .092.075.167.167.167h1.666a.167.167 0 0 0 .167-.167v-11a.167.167 0 0 0-.167-.166h-1.666Zm-1.5.166a1.5 1.5 0 0 1 1.5-1.5h1.666a1.5 1.5 0 0 1 1.5 1.5v11a1.5 1.5 0 0 1-1.5 1.5h-1.666a1.5 1.5 0 0 1-1.5-1.5v-11Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcMenuReport;
